import React from 'react';
import './IncidentLog.css';

function IncidentLog({ incidents }) {
  if (incidents.length === 0) {
    return (
      <div className="incident-log">
        <h2 className="log-title">Incident History</h2>
        <p className="no-incidents">No incidents recorded yet.</p>
      </div>
    );
  }
  
  return (
    <div className="incident-log">
      <h2 className="log-title">Incident History</h2>
      <div className="incident-count">Total Incidents: {incidents.length}</div>
      
      <div className="incidents-list">
        {incidents.map((incident, index) => (
          <div key={incident.id} className="incident-item">
            <div className="incident-number">#{incidents.length - index}</div>
            <div className="incident-details">
              <div className="incident-time">{incident.formattedDate}</div>
              
              {incident.timeSincePrevious && (
                <div className="incident-interval">
                  Time since previous: {incident.timeSincePrevious}
                </div>
              )}
              
              {incident.quote && (
                <div className="incident-quote">
                  "{incident.quote}"
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default IncidentLog;
